// 用户管理接口请求

import fetch from '../fetch';

import {
  GET_DIC_LIST,
  SEARCH_DIC_LIST,
  GET_DIC_VAL_LIST,
  ADD_DIC,
  UPDATE_DIC,
  OP_KEY,
  UPDATE_DIC_VAL,
  ADD_DIC_VAL,
  CHANNEL_SITE_LIST,
  CHANNEL_SITE_UPDATE,
  CHANNEL_SITE_SAVE,
  CHANNEL_SITE_DELETE,
  LIST_OF_ACCOUNT,
  STORE_LIST_GET,
  STOP_STORE_ADD,
  STORE_DELETE,
  STOP_STORE_DELETE,
  STORE_UPDATE,
  STORE_UPDATE_TIME,
  STORE_ECM_LIST,
  OFFLINE_STORE_LIST,
  MEMBER_BLACK_LIST_RECORD,
  AUTH_NEW_MENU_LIST_BY_USER,
  // 权限组设置
  ACTIVITY_TEAM_ADD_NEW,
  ACTIVITY_TEAM_NEW_LIST,
  ACTIVITY_TEAM_ENABLE,
  ACTIVITY_TEAM_FORBIDDEN,
  ACTIVITY_TEAM_USER_LIST,
  ACTIVITY_TEAM_USER_DELETE,
  AUTHORITY_LIST_ALL,
  AUTHORITY_LIST_BY_TEAM,
  GET_USER_LIST,
  GET_OPTIONAL_APP,
  GET_TEAM_LIST,
  SELECT_NEW_MENU_LIST,
  ADD_NEW_USER,
  GET_USER_INFO,
  ENABLE_USER,
  AUTH_FORBIDDEN_USER,
  // 主体管理
  GET_ORG_LIST,
  ORG_WXMP_LIST,
  CMMS_ORG_ADD,
  ORG_SAVE_ORG_WXMP,
  // 礼品管理
  EXCHANGE_GOODS_THEIR_GOOOD_LIST,
  EXCHANGE_GOODS_ADD_THEIR_GOODS,
  EXCHANGE_GOODS_UPDATE_THEIR_GOODS_STATUS,
  EXCHANGE_GOODS_THEIR_GOODS_DETAIL,
  EXCHANGE_GOODS_UPDATE_THEIR_GOODS,
  EXCHANGE_GOODS_SYNC_THEIR_GOODS,
  // 修改手机号
  USER_API_DELETE_AEW_USER_CHANGE_OLD_USER,
  USER_API_USER_LOG_OFF,
  // 积分规则调用方
  POINT_RULE_CALLER_GET_PAGE_LIST,
  POINT_RULE_CALLER_INSERT_OR_UPDATE,
  // 敏感词管理
  SENSITIVE_GET_SENSITIVE_WORDS,
  SENSITIVE_ADD,
  SENSITIVE_EDIT,
  SENSITIVE_DELETE_BY_ID,
  SENSITIVE_BATCH_DELETE_BY_IDS
} from '../url';

// 页面初始化时获取字典列表
function getDicList(data) {
  return fetch({
    url: GET_DIC_LIST,
    method: 'get',
    params: data
  });
};

// 搜索字典列表
function searchDicList(data) {
  return fetch({
    url: SEARCH_DIC_LIST,
    method: 'get',
    params: data
  });
};

// 获取字典键值对列表
function getDicValList(data) {
  return fetch({
    url: GET_DIC_VAL_LIST,
    method: 'get',
    params: data
  });
};

// 新增字典
function addDic(data) {
  return fetch({
    url: ADD_DIC,
    method: 'post',
    data: data
  });
};

// 修改字典
function updateDic(data) {
  return fetch({
    url: UPDATE_DIC,
    method: 'post',
    data: data
  });
};

// 启用/禁用键值对
function opKey(data) {
  return fetch({
    url: OP_KEY,
    method: 'post',
    data: data
  });
};

// 修改字典键值对
function updateDicVal(data) {
  return fetch({
    url: UPDATE_DIC_VAL,
    method: 'post',
    data: data
  });
};

// 添加字典键值对
function addDicVal(data) {
  return fetch({
    url: ADD_DIC_VAL,
    method: 'post',
    data: data
  });
};

/**
 * 渠道管理
 */
// 查询渠道列表
function channelSiteList(data) {
  return fetch({
    url: CHANNEL_SITE_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

// 新增渠道信息
function creatChannel(data) {
  return fetch({
    url: CHANNEL_SITE_SAVE,
    method: 'post',
    data: data
  });
};

// 编辑渠道信息
function updateChannel(data) {
  return fetch({
    url: CHANNEL_SITE_UPDATE,
    method: 'post',
    data: data
  });
};

// 编辑渠道信息
function deleteChannel(data) {
  return fetch({
    url: CHANNEL_SITE_DELETE + '?id=' + data,
    method: 'post',
    // data: data
  });
};

// 获取应用列表
function getListOfAccount(data) {
  return fetch({
    url: LIST_OF_ACCOUNT,
    method: 'get',
    params: data,
    isNoMsg: true
  });
};

// 跳转应用
function toApp(url, data) {
  return fetch({
    url: url,
    method: 'get',
    params: data,
    isNoMsg: true
  });
};

/**
 * 会员店铺管理
 */
// 查询店铺列表
function getStoreList(data) {
  return fetch({
    url: STORE_LIST_GET,
    method: 'post',
    data: data,
  });
};

// 新增剔除店铺
function addStopStore(data) {
  return fetch({
    url: STOP_STORE_ADD,
    method: 'post',
    data: data,
  });
};

// 剔除店铺
function deleteRewardStore(data) {
  return fetch({
    url: STORE_DELETE,
    method: 'post',
    data: data,
  });
};

// 删除剔除店铺
function deleteStopStore(data) {
  return fetch({
    url: STOP_STORE_DELETE,
    method: 'post',
    data: data,
  });
};

// 刷新店铺数据
function updateStoreList(data) {
  return fetch({
    url: STORE_UPDATE,
    method: 'post',
    data: data,
  });
};

// 查询店铺刷新时间
function getStoreUpdateTime(data) {
  return fetch({
    url: STORE_UPDATE_TIME,
    method: 'post',
    data: data,
  });
};

// 查询ECM平台
function getEcmList(data) {
  return fetch({
    url: STORE_ECM_LIST,
    method: 'post',
    data: data,
  });
};

// 查询线下门店列表
function getOfflineStoreList(data) {
  return fetch({
    url: OFFLINE_STORE_LIST,
    method: 'post',
    data: data,
  });
};

/**
 * 查询黑名单操作列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getBlackListRecord(data) {
  return fetch({
    url: MEMBER_BLACK_LIST_RECORD,
    method: 'post',
    data: data
  });
};

/**
 * 查询管理员所有权限菜单
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function newMenuListByUser(data) {
  return fetch({
    url: AUTH_NEW_MENU_LIST_BY_USER,
    method: 'get',
    params: data
  });
};

/**
 * 新增组并分配权限
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function teamAddNew(data) {
  return fetch({
    url: ACTIVITY_TEAM_ADD_NEW,
    method: 'post',
    data: data
  });
};

/**
 * 查询新平台权限组
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function activityTeamNewList(data) {
  return fetch({
    url: ACTIVITY_TEAM_NEW_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 启用禁用组
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function activityTeamEnable(data) {
  // 禁用
  let url = ACTIVITY_TEAM_FORBIDDEN;
  if (data.enable) {
    // 启用
    url = ACTIVITY_TEAM_ENABLE;
  }
  return fetch({
    url: url,
    method: 'get',
    params: data
  });
};

/**
 * 根据权限组id获取所属权限组列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function activityTeamUserList(data) {
  return fetch({
    url: ACTIVITY_TEAM_USER_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 查询数据域列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authorityListAll(data) {
  return fetch({
    url: AUTHORITY_LIST_ALL,
    method: 'get',
    params: data
  });
};

/**
 * 回显数据域权限
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authorityByTeam(data) {
  return fetch({
    url: AUTHORITY_LIST_BY_TEAM,
    method: 'get',
    params: data
  });
};

/**
 * 删除所属权限组用户
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function activityTeamUserDelete(data) {
  return fetch({
    url: ACTIVITY_TEAM_USER_DELETE,
    method: 'get',
    params: data
  });
};

/**
 * 获取管理员列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserList(data) {
  return fetch({
    url: GET_USER_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 获取管理员关联应用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getOptionalApp(data) {
  return fetch({
    url: GET_OPTIONAL_APP,
    method: 'get',
    params: data
  });
};

/**
 * 获取权限下拉列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTeamList(data) {
  return fetch({
    url: GET_TEAM_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 获取权限信息
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectNewMenuList(data) {
  return fetch({
    url: SELECT_NEW_MENU_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 新增管理员
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addNewUser(data) {
  return fetch({
    url: ADD_NEW_USER,
    method: 'post',
    data: data
  });
};

/**
 * 查询管理员详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserInfo(data) {
  return fetch({
    url: GET_USER_INFO,
    method: 'get',
    params: data
  });
};

/**
 * 禁用启用管理员
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function enableUser(data) {
  // 禁用
  let url = AUTH_FORBIDDEN_USER;
  if (data.enable) {
    // 启用
    url = ENABLE_USER;
  }
  return fetch({
    url: url,
    method: 'get',
    params: data
  });
};

/**
 * 获取主体列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getOrgList(data) {
  return fetch({
    url: GET_ORG_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 获取服务号列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getWxmpList(data) {
  return fetch({
    url: ORG_WXMP_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 新增管理员
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function cmmsOrgAdd(data) {
  return fetch({
    url: CMMS_ORG_ADD,
    method: 'post',
    data: data
  });
};

/**
 * 设置服务号保存
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function saveOrgWxmp(data) {
  return fetch({
    url: ORG_SAVE_ORG_WXMP,
    method: 'post',
    data: data
  });
};

/**
 * 礼品列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTheirGoodsList(data) {
  return fetch({
    url: EXCHANGE_GOODS_THEIR_GOOOD_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增礼品
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addTheirGoods(data, id) {
  let url = '';
  if (id) {
    url = EXCHANGE_GOODS_UPDATE_THEIR_GOODS;
  } else {
    url = EXCHANGE_GOODS_ADD_THEIR_GOODS;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 更新礼品状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateTheirGoodsStatus(data) {
  return fetch({
    url: EXCHANGE_GOODS_UPDATE_THEIR_GOODS_STATUS,
    method: 'post',
    data: data
  });
};

/**
 * 更新礼品状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTheirGoodsDetail(data) {
  return fetch({
    url: EXCHANGE_GOODS_THEIR_GOODS_DETAIL,
    method: 'get',
    params: data
  });
};

/**
 * 更新礼品状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function syncTheirGoods(data) {
  return fetch({
    url: EXCHANGE_GOODS_SYNC_THEIR_GOODS,
    method: 'post',
    data: data
  });
};

/**
 * 修改手机号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteNewUserChangeOldUser(data) {
  return fetch({
    url: USER_API_DELETE_AEW_USER_CHANGE_OLD_USER,
    method: 'get',
    params: data
  });
};

/**
 * 注销用户
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function userLogOff(data) {
  return fetch({
    url: USER_API_USER_LOG_OFF,
    method: 'get',
    params: data
  });
};

/**
 * 积分规则调用方列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointRuleCalleList(data) {
  return fetch({
    url: POINT_RULE_CALLER_GET_PAGE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 更新礼品状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdatePointRuleCaller(data) {
  return fetch({
    url: POINT_RULE_CALLER_INSERT_OR_UPDATE,
    method: 'post',
    data: data
  });
};

/**
 * 敏感词管理列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSensitiveWords(data) {
  return fetch({
    url: SENSITIVE_GET_SENSITIVE_WORDS,
    method: 'post',
    data: data
  });
};

/**
 * 新增敏感词汇
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function sensitiveWordsAdd(data) {
  return fetch({
    url: SENSITIVE_ADD,
    method: 'post',
    data: data
  });
};

/**
 * 编辑敏感词汇
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function sensitiveWordsEdit(data) {
  return fetch({
    url: SENSITIVE_EDIT,
    method: 'post',
    data: data
  });
};

/**
 * 单个删除敏感词汇
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteSensitiveById(data) {
  return fetch({
    url: SENSITIVE_DELETE_BY_ID,
    method: 'get',
    params: data
  });
};

/**
 * 批量删除敏感词汇
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function batchDeleteSensitiveByIds(data) {
  return fetch({
    url: SENSITIVE_BATCH_DELETE_BY_IDS,
    method: 'post',
    data: data
  });
};

const systemSetup = {
  getDicList,
  searchDicList,
  getDicValList,
  addDic,
  updateDic,
  opKey,
  updateDicVal,
  addDicVal,
  channelSiteList,
  creatChannel,
  updateChannel,
  deleteChannel,
  getListOfAccount,
  toApp,
  getStoreList,
  addStopStore,
  deleteRewardStore,
  deleteStopStore,
  updateStoreList,
  getStoreUpdateTime,
  getEcmList,
  getOfflineStoreList,
  getBlackListRecord,
  newMenuListByUser,
  teamAddNew,
  activityTeamNewList,
  activityTeamEnable,
  activityTeamUserList,
  authorityListAll,
  authorityByTeam,
  activityTeamUserDelete,
  getUserList,
  getOptionalApp,
  getTeamList,
  selectNewMenuList,
  addNewUser,
  getUserInfo,
  enableUser,
  // 主体管理
  getOrgList,
  getWxmpList,
  cmmsOrgAdd,
  saveOrgWxmp,
  // 礼品管理
  getTheirGoodsList,
  addTheirGoods,
  updateTheirGoodsStatus,
  getTheirGoodsDetail,
  syncTheirGoods,
  // 修改手机号
  deleteNewUserChangeOldUser,
  userLogOff,
  // 积分规则调用方
  getPointRuleCalleList,
  insertOrUpdatePointRuleCaller,
  // 敏感词管理
  getSensitiveWords,
  sensitiveWordsAdd,
  sensitiveWordsEdit,
  deleteSensitiveById,
  batchDeleteSensitiveByIds,
};

export { systemSetup };
